module.exports = __webpack_public_path__ + "static/media/downloadApp@2x.7e418af1.png";